import React from 'react'
import { LuGlobe, LuLanguages, LuPlane } from 'react-icons/lu'

const IndustryNeed = () => {
  return (
    <section className='home_section'>
      <span className='home_eyebrow'>Global outlook</span>
      <h2 className='home_heading'>In a globalized world, education must have universal applicability aligned to the needs of industry</h2>
      <p className='home_lead'>We recognize the importance of preparing students for a globalized workforce. Our programs are adaptable and relevant across diverse geographies and cultural contexts, fostering a globally competent and competitive workforce.</p>

      <div className='bento'>
        <div className='bento_card span-4 tone-brand'>
          <LuLanguages className='bento_icon' />
          <h3 className='bento_title'>Intercultural Collaboration</h3>
          <p className='bento_para'>Develop students' understanding of global cultures and practices, promoting effective communication and collaboration across diverse teams.</p>
        </div>
        <div className='bento_card'>
          <LuGlobe className='bento_icon' />
          <h3 className='bento_title'>Global Perspective</h3>
          <p className='bento_para'>Expose students to diverse perspectives, fostering a global mindset and an appreciation for different ways of thinking and working.</p>
        </div>
        <div className='bento_card span-6 tone-soft'>
          <LuPlane className='bento_icon' />
          <h3 className='bento_title'>International Opportunities</h3>
          <p className='bento_para'>Provide students with opportunities to engage in international internships, research projects, or study abroad programs, expanding their horizons and global competence.</p>
        </div>
      </div>
    </section>
  )
}

export default IndustryNeed
